<template>
  <div class="chatbot-answer-text">
    <textarea
      v-focus
      v-model="answer"
      v-on:keydown.enter.exact.prevent
      v-on:keyup.enter.exact="sendInputAnswer"
      placeholder="Digite a mensagem"
      :rows="rows"
      ref="chatbot-textarea"
    ></textarea>
    <button v-on:click.prevent="sendInputAnswer">
      <send-icon fillColor="#7bb3f3" :size="30" />
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SendIcon from "vue-material-design-icons/Send.vue";

export default {
  name: "AnswerText",
  props: {
    maxRows: {
      type: Number,
      default: 7
    }
  },
  components: {
    SendIcon
  },
  methods: {
    ...mapActions("messages", ["sendInputAnswer"])
  },
  computed: {
    rows() {
      const rows = Math.max(1, (this.answer.match(/\n/g) || []).length + 1);
      return Math.min(rows, this.maxRows);
    },
    answer: {
      get() {
        return this.$store.state.messages.inputAnswer;
      },
      set(value) {
        this.$store.commit("messages/updateInputAnswer", value);
      }
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chatbot-answer-text {
  border-top: 1px solid #afafaf38;
  display: flex;

  textarea {
    border: 0;
    padding: 15px;
    flex-grow: 1;
    outline: 0;
    resize: none;
  }

  button {
    border: 0;
    width: 60px;
    background-color: white;
    outline: 0;
    cursor: pointer;
  }
}
</style>
